import { get } from '@ManagerPortal/api';
import { QUERY_KEY } from '@ManagerPortal/containers/Schedule/Data/useShiftTypesQuery';
import { ShiftType } from '@ManagerPortal/containers/Schedule/Main/autoApiTypes';

/*
  Part of the "Cross-unit scheduling of shared employees by a single unit manager" initiative (QRND-41344).
  Endpoint returns shared shift types, as well as local shift types.
  This enables viewing local shift types that are not shared to be visible in schedule and base schedule.
*/
const CROSS_SCHEDULING_LOCAL_SHIFT_TYPES_SLUG =
  'with-cross-scheduling-local-shifttypes';

export const fetchShiftTypes = (groupId: number) =>
  get<ShiftType[]>(
    `${QUERY_KEY}/${groupId}/${CROSS_SCHEDULING_LOCAL_SHIFT_TYPES_SLUG}`,
  );

/*
  In Base Schedule, we need to fetch shift types for the shared group.
  from-group is the group we're currently standing on (and where the base schedule is)
  byGroup (substring of QUERY_KEY) is the group selected in the "Unit" dropdown inside the panel
*/
export const fetchShiftTypesForSharedGroup = (
  byGroupId: number,
  fromGroupId: number,
) => get<ShiftType[]>(`${QUERY_KEY}/${byGroupId}/from-group/${fromGroupId}`);
